<template>
  <aside
    class="t-sidebar"
    :class="{'t-sidebar--no-padding-body': noPaddingBody}"
  >
    <header v-if="$slots.header" class="t-sidebar__header">
      <slot name="header"></slot>
    </header>

    <section class="t-sidebar__body">
      <slot></slot>
    </section>

    <footer v-if="$slots.footer" class="t-sidebar__footer">
      <slot name="footer"></slot>
    </footer>
  </aside>
</template>

<script>
export default {
  name: 't-sidebar',
  props: {
    noPaddingBody: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
